<app-statistik-daekning-options class="d-flex"
    (selectLedelseAnsvarlig)="onLedelseAnsvarligSelected($event)"
    (selectKundeAnsvarlig)="onKundeAnsvarligSelected($event)"
    (selectSagsAnsvarlig)="onSagsAnsvarligSelected($event)"
    (selectKoncern)="onKoncernSelected($event)"
    (periodeChange)="onPeriodeChange($event)"
    (showNullableObjects)="onShowNullableObjectsChange($event)"
    (exportExcel)="onExport()"
    [laID]="selectedLAId"
    [kaID]="selectedKAId"
    [laCards]="laCards"
    [kaCards]="kaCards"
    [saCards]="saCards"
    [koncerns]="koncernList"
    [periode]="periode"
></app-statistik-daekning-options>
<div class="table__viewport">
    <table class="table table-hover table-striped table-sm table-frame__body">
        <thead class="fixed-top position-fixed position-sticky">
        <tr>
            <th>Kunde</th>
            <th></th>
            <th>Navn</th>
            <th class="text-end">Brugt</th>
            <th class="text-end">Faktureret</th>
            <th class="text-end">Dækning</th>
            <th class="text-end">%</th>
        </tr>
        </thead>
        <tbody>

        <ng-container *ngFor="let kunde of filteredDaekning; trackBy: trackDaekningKID">
            <ng-container *ngIf="(kunde.brugt > 0 || kunde.faktureret > 0) || showNullableObjects">
                <tr class="item__tr">
                    <td (click)="OpenKundeModal(kunde)" class="link-td"> {{ kunde.glKundeNr }} </td>
                    <td (click)="openFaktureringModal(kunde.glKundeNr)" class="link-td"> F</td>
                    <td (click)="navigateToClientBasis(kunde.kid)" class="link-td"> {{ kunde.navn }} </td>
                    <td class="text-end"> {{ kunde.brugt | currency:'DKK':'':'1.0-0':'da' }} </td>
                    <td class="text-end"> {{ kunde.faktureret | currency:'DKK':'':'1.0-0':'da' }} </td>
                    <td class="text-end"> {{ kunde.faktureret - kunde.brugt | currency:'DKK':'':'1.0-0':'da' }} </td>
                    <td class="text-end"> {{calculateDaekningsGrad(kunde.brugt, kunde.faktureret) | currency:'DKK':'':'1.0-0':'da'}}</td>
                </tr>
            </ng-container>
        </ng-container>

        </tbody>

        <tfoot class="fixed-bottom position-fixed position-sticky">
            <th>Total</th>
            <th></th>
            <th></th>
            <th class="text-end">{{brugtTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
            <th class="text-end">{{faktureretTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
            <th class="text-end">{{daekningsgradTotal() | currency:'DKK':'':'1.0-0':'da'}}</th>
            <th class="text-end">{{calculateDaekningsGrad(brugtTotal(), faktureretTotal()) | currency:'DKK':'':'1.0-0':'da'}}</th>
        </tfoot>
    </table>
</div>
